module.exports = __webpack_public_path__ + "static/img/report-center.c5656d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/report-center.png
// module id = WARQ
// module chunks = 1